module Main where

import Prelude

import App (HereaboutEnv, runAppM)
import App.Button as Button
import AppComponent as App
import Clerk (initClerk)
import Data.Either (Either(..))
import Data.Maybe (Maybe(..))
import Data.String as String
import Effect (Effect)
import Effect.Aff (Aff, launchAff_)
import Effect.Class.Console (log)
import Effect.Now (nowDateTime)
import Halogen (liftAff, liftEffect)
import Halogen as H
import Halogen.Aff as HA
import Halogen.HTML as HH
import Halogen.VDom.Driver (runUI)
import Hereabout.Data.Route (HereaboutPage(..), Route(..), routeCodec)
import Promise (then_)
import Routing.Duplex (parse)
import Routing.Hash as Hash
import Routing.PushState as PS
import Web.DOM.Element (setScrollTop)
import Web.HTML as WH
import Web.HTML.HTMLElement as HElem
import Web.HTML.Window (scroll)

-- main :: Effect Unit
-- main = HA.runHalogenAff do
--   body <- HA.awaitBody
--   runUI Button.component unit body

rootComponent :: forall o. HereaboutEnv -> H.Component App.Query Unit o Aff
rootComponent env = H.hoist (runAppM env) App.component

main :: Effect Unit
main = HA.runHalogenAff do
  now <- liftEffect nowDateTime
  clerk <- initClerk
  pushStateInterface <- liftEffect PS.makeInterface
  hash <- liftEffect Hash.getHash
  
  --code <- liftEffect WT.captureAuthorisationCode
  --tokenRef <- liftEffect $ R.new Nothing
  --interface <- liftEffect $ makeInterface
  let env = 
        { baseUrl : "https://api.hereabout.uk"
        , uiBaseUrl : "https://hereabout.uk"
        , clerkInstance : clerk
        , pushStateInterface : pushStateInterface
        }
--   let items = 
--         { authCode : code
--         }
  body <- HA.awaitBody
  halogenIO <- runUI (rootComponent env) unit body


  case parse routeCodec $ hash of
    Right GPSFeedRoute -> pure unit
    Left _ -> pure unit
    Right r ->
      liftEffect $ launchAff_ do
        _ <- halogenIO.query $ H.mkTell $ App.ChangeLocationHash r
        log "Handle initial fragment"
        pure unit

  void $ liftEffect $ PS.matchesWith (parse routeCodec) 
      ( \old new -> do
        when (old /= Just new) $ launchAff_ do
          _ <- halogenIO.query $ H.mkTell $ App.ChangeLocationHash new
          log "Path changed"
          w <- liftEffect WH.window
          liftEffect $ scroll 0 0 w
          pure unit
      ) pushStateInterface
